export default __webpack_public_path__ + "static/media/bancontact.036cc2ce.png";